import { useEffect, useState } from "react";
import { captureInstallPrompt, isRunningStandalone, type BeforeInstallPromptEvent } from "../pwa";
import { detectInAppBrowser } from "../env";

/**
 * Gợi ý cài PWA lên màn hình chính. KHÔNG hiện trong in-app browser
 * (docs/73-facebook-integration.md §3.4 — cài đặt không hoạt động đúng từ trong WebView của
 * Facebook/Messenger/Instagram/Zalo, và các app đó cũng không bắn `beforeinstallprompt`).
 */
export default function InstallBanner() {
  const [promptEvent, setPromptEvent] = useState<BeforeInstallPromptEvent | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const [installed, setInstalled] = useState(false);

  const { isInApp } = detectInAppBrowser();

  useEffect(() => {
    if (isInApp) return; // không lắng nghe/gợi ý gì trong WebView — nguyên tắc cứng
    return captureInstallPrompt(setPromptEvent);
  }, [isInApp]);

  if (isInApp || dismissed || installed || isRunningStandalone() || !promptEvent) return null;

  return (
    <div className="install-banner" role="status">
      <span>Cài QR Studio vào màn hình chính để mở nhanh hơn lần sau.</span>
      <div className="install-banner-actions">
        <button
          type="button"
          className="update-banner-btn"
          onClick={() => {
            promptEvent
              .prompt()
              .then(() => promptEvent.userChoice)
              .then((choice) => {
                if (choice.outcome === "accepted") setInstalled(true);
                setPromptEvent(null);
              })
              .catch(() => setPromptEvent(null));
          }}
        >
          Cài đặt
        </button>
        <button type="button" className="update-banner-dismiss" onClick={() => setDismissed(true)} aria-label="Đóng">
          ✕
        </button>
      </div>
    </div>
  );
}
